<div class="row p-4">
    <div class="col-md-12 text-center">
        <h3>{{headerstmt }}</h3>
    </div>
    </div>
    <div class="row mb-4">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="text-center">
                <p class="errorMsg font-weight-bold">Payment Rejected for WebFiling ID - {{urlWebFilingId}}</p>
                    <p class="errorMsg font-weight-bold">There was an issue with your payment and it was rejected.  Please try again....</p>
                </div><div class="row d-print-none">
        <div class="col-md-12 text-center">
         	<input type="button" class="btn btn-primary mb-2 " (click)="return_pagemntOptions()" value="Return to Payment Options">&nbsp;&nbsp;
        </div>
    </div>
            </div>
        </div>
    </div>
</div>